var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58433",
    "data-name": "Group 58433",
    transform: "translate(-781 -94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7990",
    "data-name": "Rectangle 7990",
    width: 70,
    height: 70,
    rx: 17,
    transform: "translate(781 94)",
    fill: "#f5fbfa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58431",
    "data-name": "Group 58431",
    transform: "translate(787.491 85.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42382",
    "data-name": "Path 42382",
    d: "M54.109,38.283V58.717a3.431,3.431,0,0,1-3.43,3.43H20.117a3.431,3.431,0,0,1-3.43-3.43V38.283a3.431,3.431,0,0,1,3.43-3.43H50.679a3.431,3.431,0,0,1,3.43,3.43Z",
    transform: "translate(-6.617 -6.618)",
    fill: "#f8d728"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42383",
    "data-name": "Path 42383",
    d: "M54.13,38.283V53.865A3.424,3.424,0,0,1,50.7,57.291H20.142a3.427,3.427,0,0,1-3.43-3.426V38.283a3.431,3.431,0,0,1,3.43-3.43H50.7a3.416,3.416,0,0,1,3.406,3.076v0a3.406,3.406,0,0,1,.02.35Z",
    transform: "translate(-6.64 -6.618)",
    fill: "#c3f3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42384",
    "data-name": "Path 42384",
    d: "M22.892,62.147h-2.75a3.431,3.431,0,0,1-3.43-3.43V38.283a3.431,3.431,0,0,1,3.43-3.43h2.75a3.431,3.431,0,0,0-3.43,3.43V58.717A3.431,3.431,0,0,0,22.892,62.147Z",
    transform: "translate(-6.64 -6.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42386",
    "data-name": "Path 42386",
    d: "M160.07,445.095H142.347a.418.418,0,0,1-.385-.581l.35-.821a2.167,2.167,0,0,1,1.992-1.316h13.81a2.167,2.167,0,0,1,1.992,1.316l.35.821A.418.418,0,0,1,160.07,445.095Z",
    transform: "translate(-122.065 -382.278)",
    fill: "#f8d728"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42387",
    "data-name": "Path 42387",
    d: "M106.04,92.8l-13.9,4.125L78.243,92.8l13.9-4.125Z",
    transform: "translate(-63.36 -56.228)",
    fill: "#929497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42388",
    "data-name": "Path 42388",
    d: "M82.934,92.8,94.485,96.23l-2.346.7L78.243,92.8l13.9-4.125,2.346.7Z",
    transform: "translate(-63.36 -56.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42389",
    "data-name": "Path 42389",
    d: "M183.144,149.8v-6.6c0-.908-3.023-1.644-6.752-1.644s-6.752.737-6.752,1.644v6.6Z",
    transform: "translate(-147.61 -104.977)",
    fill: "#929497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42390",
    "data-name": "Path 42390",
    d: "M177,141.54c-3.4.086-6.058.786-6.058,1.638v6.6h-1.293v-6.6c0-.908,3.021-1.646,6.75-1.646C176.6,141.532,176.8,141.536,177,141.54Z",
    transform: "translate(-147.619 -104.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_525",
    "data-name": "Ellipse 525",
    cx: 6.753,
    cy: 1.644,
    rx: 6.753,
    ry: 1.644,
    transform: "translate(22.028 43.176)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42391",
    "data-name": "Path 42391",
    d: "M177.565,229.213c-.377.02-.77.028-1.167.028-3.729,0-6.75-.739-6.75-1.646s3.021-1.642,6.75-1.642c.4,0,.79.008,1.167.028-3.178.13-5.595.805-5.595,1.615s2.416,1.489,5.595,1.619Z",
    transform: "translate(-147.618 -182.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58425",
    "data-name": "Group 58425",
    transform: "translate(9.509 27.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42392",
    "data-name": "Path 42392",
    d: "M44.063,27.674H13.5a4,4,0,0,0-3.991,3.991V52.1A4,4,0,0,0,13.5,56.091H25.118v3.447h-2.88a2.727,2.727,0,0,0-2.508,1.657l-.349.82a.98.98,0,0,0,.9,1.364H38a.98.98,0,0,0,.9-1.363l-.35-.822a2.727,2.727,0,0,0-2.508-1.656h-2.88V56.091h10.9A4,4,0,0,0,48.054,52.1V31.665A4,4,0,0,0,44.063,27.674Zm-6.539,33.96.265.621H20.5l.264-.62a1.6,1.6,0,0,1,1.476-.976h13.81a1.6,1.6,0,0,1,1.475.975Zm-5.478-2.1h-5.8V56.09h5.8ZM46.931,52.1a2.872,2.872,0,0,1-2.868,2.868H13.5A2.872,2.872,0,0,1,10.632,52.1V50.013A3.979,3.979,0,0,0,13.5,51.234H44.063a3.979,3.979,0,0,0,2.868-1.221Zm0-4.852a2.87,2.87,0,0,1-2.868,2.864H13.5a2.87,2.87,0,0,1-2.868-2.864V31.665A2.872,2.872,0,0,1,13.5,28.8H44.063a2.872,2.872,0,0,1,2.868,2.868V47.247Z",
    transform: "translate(-9.509 -27.674)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42393",
    "data-name": "Path 42393",
    d: "M100.826,101.681h-.479a.561.561,0,0,0,0,1.123h.479a.561.561,0,1,0,0-1.123Zm-.843-15.508a.569.569,0,0,0-.4-.532l-13.9-4.129a.553.553,0,0,0-.319,0l-13.9,4.125a.561.561,0,0,0,0,1.076l6.744,2v5.7s0,0,0,.008c0,2.144,6.566,2.206,7.315,2.206s7.315-.062,7.315-2.206c0,0,0-.005,0-.008v-5.7l6.023-1.787v4a.561.561,0,1,0,1.123,0C99.983,88.487,99.982,86.118,99.982,86.173Zm-8.268,6.966c-1.909-.883-5.638-.918-6.191-.918s-4.282.035-6.191.918V87.864c.263-.41,2.506-1.118,6.191-1.118s5.928.708,6.191,1.118ZM85.524,95.51c-3.583,0-5.8-.67-6.166-1.084.361-.413,2.581-1.082,6.166-1.082s5.805.669,6.166,1.082C91.328,94.84,89.107,95.51,85.524,95.51ZM92.8,87.56c-.528-1.879-6.557-1.937-7.273-1.937s-6.741.058-7.272,1.935L73.6,86.176l11.925-3.54L97.45,86.179Z",
    transform: "translate(-66.251 -77.281)",
    fill: "#1b2737"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.50890b979e7e71e6374c90e0e762bd46.svg";
export { ForwardRef as ReactComponent };